import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchSettingData = createAsyncThunk(
    'settings/fetchSettingData',
    async (type) => {
        try {
            const response = await api.get('/settings', {
                params: {
                    "type": type,
                }
            });
            console.log(response)
            return response.data.data;
        } catch (error) {
            return error;
        }

    }
)

export const settingSlice = createSlice({
    name: "setting",
    initialState: {
        loading: false,
        error: null,
        settings: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchSettingData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchSettingData.fulfilled, (state, action) => {
                state.loading = false;
                state.settings = action.payload;
            })
            .addCase(fetchSettingData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});
export const { getSettingRequest, getSettingSuccess, getSettingFailure } = settingSlice.actions;
export default settingSlice.reducer;
